import type { BulkOperationsApi } from './api';

export enum BulkOperationType {
  Deploy = 'deploy',
  Destroy = 'destroy',
  Approve = 'approve',
  Cancel = 'cancel',
  RunTask = 'run-task',
  Archive = 'archive',
  Lock = 'lock',
  Unlock = 'unlock',
  CancelQueuedDeployments = 'cancel-queued-deployments',
  AddTags = 'add-tags',
  RemoveTags = 'remove-tags'
}

// The single source for which item statuses are final. The status sync lambda uses it as its
// no-regress guard and the frontend derives "still running" from it, so the two cannot drift.
export const TERMINAL_BULK_OPERATION_ITEM_STATUSES: BulkOperationsApi.BulkOperationItemStatus[] = [
  'FAILED_TO_START',
  'COMPLETED',
  'SUCCESS',
  'FAILURE',
  'CANCELLED',
  'ABORTED',
  'TIMEOUT',
  'INTERNAL_FAILURE',
  'SKIPPED',
  'NEVER_DEPLOYED'
];
